import { AdminType, APIGet, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { IGreenFee, IItem, IPowerCart, IStub } from "redux/reducers/models/ticket";

interface IGetTicketStub {
  code?: string;
  customer_id?: number;
  id?: number;
  status?: string;
  search?: string;
  extended?: boolean;
  ids?: number[];
  valid_facilities?: boolean;
  shared?: boolean;
  redemption_products?: boolean;
  limit?: number;
  offset?: number;
}

interface IGetTicketStubPdf {
  order_id?: number;
  order_line_item_id?: number;
  ticket_stub_ids?: any[];
  format?: "zebra";
}

export interface IGetTicketStubValidateRes {
  redemption_products: {
    green_fee: IGreenFee;
    items: IItem[];
    power_cart: IPowerCart;
  };
  stub: IStub;
}

export async function GetTicketValidate(params: { code: string }, useGlobalLoader: boolean) {
  return await APIGet<IGetTicketStubValidateRes>(
    APIUrl(AdminType.FacilityAdmin, "/ticket/stub/validate"),
    params,
    useGlobalLoader,
  );
}

//GET Ticket Stub
export async function GetTicketStub(params: IGetTicketStub, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/ticket/stub"), params, useGlobalLoader, token);
}

//GET Ticket Stub Redemption products
export async function GetTicketStubRedemption(params: IGetTicketStub, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/ticket/stub/redemption-products"),
    params,
    useGlobalLoader,
    token,
  );
}

//PUT Ticket Stub
export async function PutTicketStub(params: IGetTicketStub, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/ticket/stub"), params, useGlobalLoader);
}

export async function PutUnredeemStub(params: { id: number }, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/ticket/stub/unredeem"), params, useGlobalLoader);
}

export async function PutVoidStub(params: { id: number }, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/ticket/stub/void"), params, useGlobalLoader);
}

export async function PutTicketStubRedeem(params: { code: string }, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/ticket/stub/redeem"), params, useGlobalLoader);
}

export async function PutTicketStubRedeemMultiple(
  params: { ticket_stub_ids: number[]; customer_id?: number, booking_participant_id?: number, order_id?: number },
  useGlobalLoader: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/ticket/stub/redeem/multiple"), params, useGlobalLoader);
}

export async function GetTicketStubPdf(params: IGetTicketStubPdf, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/ticket/stub/pdf"), params, useGlobalLoader);
}

export async function PutDisableTransfer(params: { selected_ticket_stub_ids: number[] }, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/ticket/stub/disable-transfer"), params, useGlobalLoader);
}
